export default "__VITE_ASSET__BZN2ryYS__"